import { render, staticRenderFns } from "./OamnCourseNavigation.vue?vue&type=template&id=51a02772&"
import script from "./OamnCourseNavigation.vue?vue&type=script&lang=js&"
export * from "./OamnCourseNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports